<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../assets/images/return.png"><span>新增物资</span>
      </div>
      <div class="list-wrapper">
        <div class="row-item">
          <label>条码</label>
          <input type="text" placeholder="请输入或扫描条码" >
        </div>
        <div class="row-item">
          <label>名称</label>
          <input type="text" placeholder="请输入物品名称" >
        </div>
        <div class="row-item" @click="classifyClick">
          <label>分类</label>
          <input type="text" placeholder="请选择物品分类" >
          <img src="../../assets/images/right_jt.png">
        </div>
        <div class="row-item" @click="unitClick">
          <label>单位</label>
          <input type="text" placeholder="请选择单位" >
          <img src="../../assets/images/right_jt.png">
        </div>
        <div class="row-item">
          <label>金额</label>
          <input type="text" placeholder="请输入金额" >
        </div>
        <div class="row-item">
          <label>规格</label>
          <input type="text" placeholder="请输入规格" >
        </div>
        <div class="row-item">
          <label>备注</label>
          <input type="text" placeholder="请输入备注" >
        </div>
        <div class="row-item" style="border-bottom: none;">
          <label>上传图片</label>
        </div>
        <div class="row-item" style="border-bottom: none;padding-top: 0;">
          <!-- 上传图片 -->
          <div class="uploadImg">
            <div class="uploadImgFile">
              <input class="uploadImg" @change="uploadFile" type="file">
            </div>
            <div class="uploadImgList" v-for="(image, image_key) in imageList" :key="image_key">
              <img class="img" :src="image" @click="previewImage(image)">
              <img class="del" @click="deleteImage(image_key)" src="../../assets/images/repairman-del.png">
            </div>
          </div>
          <!-- 预览图片 -->
          <div class="previewimg" v-if="previewFile">
            <div @click="previewclose"></div>
            <img :src="previewimg">
          </div>
        </div>
      </div>
    </div>
    <button class="preserve">保存</button>
    <!-- 选择单位 -->
    <div class="select-mask" v-if="unitPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择单位<img class="close-mask" @click="unitClose" src="../../assets/images/close.png"></div>
          <div class="level">暂不选择</div>
          <div class="level">提</div>
          <div class="level">台</div>
          <div class="level">包</div>
        </div>
      </div>
    </div>
    <!-- 选择分类 -->
    <div class="select-mask" v-if="classifyPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择分类<img class="close-mask" @click="classifyClose" src="../../assets/images/close.png"></div>
          <div class="classify-list">
            <div class="first-category" v-for="(classify, index) in classifyList" :key="index" @click="clickEvent(index)">
              <div class="level">
                <img v-if="current === index" class="arrow" src="../../assets/images/material-crudejt-down.png">
                <img v-else class="arrow" src="../../assets/images/material-crudejt-right.png">{{classify.name}}
              </div>
              <div class="second-category" :class="{active: current === index}">
                <div class="level" v-for="(children, children_key) in classify.children" :key="children_key">{{children.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'materialAdd',
  metaInfo: {
    title: '物资管理'
  },
  data () {
    return {
      access_token: '', // tob access_token
      imageList: [], // 保存图片集合
      imageListId: [], // 选中的图片id
      previewimg: '', // 预览图片
      previewFile: false, // 预览默认关闭
      maxSize: 500, // 上传图片限制最大为500kb
      formData: '',
      unitPopup: false, // 选择单位
      classifyPopup: false, // 选择分类
      current: -1,
      classifyList: [
        {
          name: '固定资产',
          children: [
            {
              name: '卷纸'
            }
          ]
        },
        {
          name: '办公用品',
          children: [
            {
              name: '打印纸'
            },
            {
              name: '卷纸'
            },
            {
              name: '笔'
            }
          ]
        }
      ]
    }
  },
  created () {
    this.getAccessToken()
  },
  methods: {
    // 选择上传图片
    uploadFile (e) {
      if (this.imageList.length < 9) {
        let that = this
        var files = e.target.files[0]

        var reader = new FileReader()
        reader.readAsDataURL(files)
        // 监听文件读取结束后事件
        reader.onloadend = function (e) {
          // var dx = (e.total / 1024) / 1024
          // if (dx >= 2) {
          //   alert('文件大小大于2M')
          //   return
          // }
          that.imageList.push(e.target.result)

          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            // 以上是将选择的图片展示出来
            let originWidth = img.naturalWidth
            let originHeight = img.naturalHeight
            let originSize = files.size / 1024 // 计算图片多少kb
            // 将图片绘制到canvas上进行压缩
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')
            let maxSize = that.maxSize
            if (originSize <= maxSize) {
              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', files)
            } else {
              let mul = originSize / maxSize
              let targetWidth = originWidth / mul
              let targetHeight = originHeight / mul
              canvas.width = targetWidth
              canvas.height = targetHeight
              context.clearRect(0, 0, targetWidth, targetHeight) // 清除画布
              context.drawImage(img, 0, 0, targetWidth, targetHeight) // 画图

              let dataURL = canvas.toDataURL('image/jpeg') // 将其转化成base64字符串
              let blob = that.dataURItoBlob(dataURL) // 转化为blob格式
              var fileName = new Date().getTime() + '.jpeg'

              that.formData = new FormData() // 声明一个FormData对象
              that.formData.append('file', blob, fileName)
            }
            var options = { // 设置axios的参数
              url: '/api/Upload/uploadpicture?access_token=' + that.access_token,
              data: that.formData,
              method: 'post',
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            that.axios(options).then((res) => {
              that.imageListId = that.imageListId.concat(res.data.data.id)
              console.log(that.imageListId)
            })
          }
        }
      } else {
        this.$toast({
          message: '最多选择9张图片',
          duration: 5000
        })
      }
      e.target.value = '' // 解决input type=file 同一个文件二次上传无效的问题
    },
    // base64格式转化为blob对象
    dataURItoBlob (dataURI) {
      let byteString = atob(dataURI.split(',')[1])
      let mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      let ab = new ArrayBuffer(byteString.length)
      let ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: mimeString })
    },
    // 删除上传图片
    deleteImage (e) {
      this.imageList.splice(e, 1)
      this.imageListId.splice(e, 1)
    },
    // 预览图片
    previewImage (e) {
      this.previewFile = true
      this.previewimg = e
    },
    // 关闭预览
    previewclose () {
      this.previewFile = false
    },
    // 获取tob accessToken
    getAccessToken () {
      this.axios.get('/wechat/repair/tobAccessToken')
        .then((res) => {
          if (res.data.status === 1) {
            this.access_token = res.data.data.access_token
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 点击单位
    unitClick () {
      this.unitPopup = true
    },
    // 关闭单位弹出
    unitClose () {
      this.unitPopup = false
    },
    // 点击分类
    classifyClick () {
      this.classifyPopup = true
    },
    // 关闭分类弹出
    classifyClose () {
      this.classifyPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.classifyPopup = false
      this.unitPopup = false
    },
    // 点击展开分类
    clickEvent (index) {
      if (this.current === index) {
        this.current = -1
      } else {
        this.current = index
      }
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #ffffff;
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.preserve {
  width: 100%;
  height: 50px;
  border: none;
  font-size: 16px;
  letter-spacing: 2px;
  color: #ffffff;
  background-color: #ff7c12;
}
.list-wrapper .row-item {
  display: flex;
  margin: 0 15px;
  padding: 10px 0;
  border-bottom: 1px solid #f6f6f6;
  font-size: 15px;
}
.list-wrapper .row-item label {
  width: 100px;
}
.list-wrapper .row-item input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 15px;
}
.list-wrapper .row-item img {
  width: 12px;
  height: 12px;
  vertical-align: top;
  padding-top: 5px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .active {
  display: block !important;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content .second-category {
  margin-left: 25px;
  /* display: none; */
}
.select-mask .select-mask-inner .select-mask-content .arrow {
  width: 10px;
  height: 10px;
  padding-right: 6px;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/MaterialAdd.vue